module.exports = __webpack_public_path__ + "static/img/banner-bg2.07df3a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-bg2.jpg
// module id = I61P
// module chunks = 49